module.exports = __webpack_public_path__ + "static/lake-success-1a81839fca39fe4b13bc5638bf1ad36f.jpg";